import { NestedBlock } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/blocks.state'
import { Breakpoint, breakpointSiteheader } from '@shared/Frontend/utils/breakpoints'
import { SiteheaderState } from 'EntryPoint/Frontend/root/siteheader/siteheader.state'
import { List, Map } from 'immutable'
import {
  AsyncState,
  HttpResult,
  loadedAsyncState,
  loadingAsyncState,
  none,
  Option,
  some,
  unloadedAsyncState
} from 'widgets-for-react'
import { RootState } from '../../../../root/state'
import { CMSState } from '../cms/blocks/types.gen'
import { buttonWrapper, linkWrapper } from '../cms/blocks/utils.gen'
import { DownloadBlockProps } from '../cms/blocks/widgets/downloadBlock.gen'
import { Page } from '../cms/page/types.gen'
import {
  getDrupalNode,
  getOverview,
  getPressReleases,
  loadBreadcrumbs,
  loadFooterColumn,
  loadHeader,
  loadPrivacyMenu,
  parse_menu
} from '../drupal/api/api.mod'
import { downloadBlock, DrupalBlock_To_WidgetBlock } from '../drupal/drupal_to_cms.mod'
import { GetCookiebarButton, GetCookiebarContent } from '../drupal/rendering/cookiebar_utils.mod'
import { GetDrupalBlockImagesLoaders } from '../drupal/rendering/image_utils.mod'
import { CustomBlock } from '../drupal/types_and_parser/custom_blocks.mod'
import {
  Breadcrumb,
  CustomParsedEntity,
  CustomParsedNode,
  ParsedMenuItem
} from '../drupal/types_and_parser/extra_types.mod'
import { Block } from '../drupal/types_and_parser/standard_blocks.gen'
import { ParsedMediaImage, ParsedNodeStory, ParsedParagraph } from '../drupal/types_and_parser/types.ext.gen'
import { getFormState, getFormStateMonitorCampaign } from '../form/api'
import { BatchRequestResponse } from '../http_batch'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { expandProps } from './blocks/custom_blocks/widgets/expandBlock.mod'
import { PressReleaseItem } from './blocks/custom_blocks/widgets/pressReleasesBlock'
import { doubleTextImageClasses, hubspotIframeBlockClasses, textImageClasses } from './blocks/style.mod'
import { getPressContact } from './utils/custom_api'
import {
  developmentblock_src,
  developmentblock_srcset,
  get_default_data_src,
  get_default_data_srcset
} from './utils/extra_images.mod'
import { getLangFromUrl } from './utils/history.mod'
import React = require('react')

export const inert = ({ siteheader, breakpoint }: { siteheader: SiteheaderState; breakpoint: Breakpoint }) =>
  siteheader.mode == 'open' && !breakpointSiteheader(breakpoint)

const parseImage = (i: ParsedMediaImage | undefined): number =>
  i != undefined &&
  i.field_media_image != undefined &&
  i.field_media_image.image != undefined &&
  i.field_media_image.image.id != null
    ? i.field_media_image.image.id
    : 0

export type PublicSite_CustomPageData = {
  node: CustomParsedNode
  breadcrumb: AsyncState<List<Breadcrumb>>
}

export const getDrupalLanguage = (l: string): 'nl' | 'fr' | 'en' | 'pl' =>
  l == 'be_nl' ? 'nl' : l == 'be_fr' ? 'fr' : l == 'nl' ? 'nl' : 'en'

const _getBlocks = (pageValue: CustomParsedEntity) => {
  if (pageValue.entity_type == 'node') {
    var pageList: List<ParsedParagraph> =
      pageValue.bundle == 'update_overview' ? pageValue.field_page_content_optional : pageValue.field_page_content

    if (pageValue.bundle == 'update') {
      // Feedback received -> Press contact should not be included on update pages by default.
      // pageList = pageList.push({ bundle: "press_contact" } as any);
      pageList = pageList.push({ bundle: 'updates' } as any)
      // pageList = pageList.push({ bundle: "related_content_load_more" } as any);
      // Push related content block
    }

    const list = pageList.map((b) => ({ ...b, kind: b.bundle })).toArray()
    return list as (Block | CustomBlock)[]
  }

  return [] // will never happen
}

export const getPage = (slug: string): AsyncState<Page> =>
  loadingAsyncState(() =>
    getDrupalNode(slug)
      .then<HttpResult<Page>>((page: HttpResult<CustomParsedEntity> & { is_preview: boolean }) => {
        if (page.kind != 'result') {
          // to_edit_state.isPreview = false;
          return { kind: 'failed', status: 404 }
        }
        if (page.value.entity_type != 'node') {
          // to_edit_state.isPreview = false;
          return { kind: 'failed', status: 404 }
        }
        let breadcrumbs: AsyncState<List<Breadcrumb>> = loadedAsyncState(List())
        if (!page.is_preview) {
          breadcrumbs = loadBreadcrumbs(page.value.language_links.get(page.value.language), getLangFromUrl())
        }
        // to_edit_state.isPreview = page.is_preview;
        return {
          kind: 'result',
          value: {
            blocks: _getBlocks(page.value),
            extra_data: { node: { ...page.value, is_preview: page.is_preview }, breadcrumb: breadcrumbs }
          },
          status: 200
        }
      })
      .catch((e) => {
        console.error('This error occurred in getPage:', e)
        return e
      })
  )

export const extracted_batch = (s: RootState, res: BatchRequestResponse[], reloadAll: boolean, lang: string) => {
  const s1 = { ...s }

  const headerReq = res.find((r) => r.requestId == 'header')
  if (headerReq && headerReq.data.kind == 'result' && !reloadAll) {
    const headerList: Array<ParsedMenuItem> = parse_menu(JSON.parse(headerReq.data.value))
    s1.state.siteheader.navLinks = loadedAsyncState(headerList)
  } else {
    s1.state.siteheader.navLinks = loadingAsyncState(() => loadHeader(lang))
  }

  const footerReq = res.find((r) => r.requestId == 'footer')
  if (footerReq && footerReq.data.kind == 'result' && !reloadAll) {
    const footerList: Array<ParsedMenuItem> = parse_menu(JSON.parse(footerReq.data.value))
    s1.state.footer.cols = loadedAsyncState(footerList)
  } else {
    s1.state.footer.cols = loadingAsyncState(() => loadFooterColumn(lang, 1))
  }

  // const languages_req = res.find((r) => r.requestId == 'languages')
  // if (languages_req && languages_req.data.kind != 'result') {
  //   s1.state.header.menuHeader.languages = loadingAsyncState(() => Api.loadLanguages())
  // }

  // const top_menu_req = res.find((r) => r.requestId == 'top_menu')
  // if (top_menu_req && top_menu_req.data.kind != 'result' || reloadAll) {
  //   s1.state.header.topMenu = loadingAsyncState(() => loadTopMenu(lang))
  // }

  // const country_menu_req = res.find((r) => r.requestId == 'top_menu')
  // if (country_menu_req && country_menu_req.data.kind != 'result' || reloadAll) {
  //   s1.state.header.countryMenu = loadingAsyncState(() => loadCountryMenu(lang))
  // }

  const privacy_menu_req = res.find((r) => r.requestId == 'privacy_menu')
  if ((privacy_menu_req && privacy_menu_req.data.kind != 'result') || reloadAll) {
    s1.state.footer.privacyMenu = loadingAsyncState(() => loadPrivacyMenu(lang))
  }

  // if (defaultLanguage != 'ru') {
  //   const vacancies_req = res.find((r) => r.requestId == 'vacancies')
  //   console.log('vacancies_req');
  //   if (vacancies_req && vacancies_req.data.kind != 'result' || reloadAll) {
  //     s1.state.footer.new_vacancies = loadingAsyncState(() => loadVacancies(lang, "", [], []).then(r => r.kind == "result" ? { ...r, value: r.value.take(3).toList() } : r))
  //   }
  // }

  return s1
}

export const CustomBlock_To_Widget = (c: CustomBlock, block_index: number): Option<CustomBlockData> => {
  if (c.kind == 'magazine_embed') {
    return some({
      kind: 'magazineEmbedBlock',
      value: [{ embed_id: c.field_magazine_embed_id == undefined ? 'avqirtvait' : c.field_magazine_embed_id }, {}]
    })
  }
  if (c.kind == 'iframe_code') {
    return some({
      kind: 'iframeCodeBlock',
      value: [
        {
          index: block_index,
          inview: {
            threshold: 0,
            triggerOnce: false
          },
          iframe: c?.field_iframe_code
        },
        {}
      ]
    })
  }
  if (c.kind == 'extra_navigational_element') {
    // TODO: Add props from CMS
    return some({
      kind: 'otherKeyProjectsBlock',
      value: [
        {
          block_index: block_index,
          field_extra_elements: c.field_extra_elements,
          updateNodes: unloadedAsyncState()
        },
        {}
      ]
    })
  }
  if (c.kind == 'related_content_load_more') {
    return some({
      kind: 'relatedContentBlock',
      value: [
        {
          block_index,
          title: c?.field_title,
          link: c?.field_links?.map((l) => linkWrapper({ title: l.title, url: l.url })).toArray(),
          nodes: unloadedAsyncState(),
          allUpdates: unloadedAsyncState(),
          max_nodes: 6
        },
        {}
      ]
    })
  }
  if (c.kind == 'personBlock') {
    return some({
      kind: 'personBlock',
      value: [
        {
          block_index: block_index,
          name: c.value.name,
          role: 'whatever'
        },
        {}
      ]
    })
  } else if (c.kind == 'campaign_manager') {
    return some({
      kind: 'campaignMonitorBlock',
      value: [
        {
          block_index,
          form_id: c.field_form,
          form_intro: c.field_body,
          form_title: c.field_title,
          state: getFormStateMonitorCampaign(c.field_form),
          collapsed_status: c.field_title.toLocaleLowerCase().includes('job alert') ? 'collapse_closed' : 'no_collapse'
        },
        {}
      ]
    })
  } else if (c.kind == 'form') {
    return some({
      kind: 'formBlock',
      value: [
        {
          block_index,
          form_id: c.field_form_list,
          state: getFormState([], c.field_form_list)
        },
        {}
      ]
    })
  } else if (c.kind == 'press_releases') {
    return some({
      kind: 'pressReleasesBlock',
      value: [
        {
          blockIndex: block_index,
          item_limit: c.field_item_limit,
          show_year_filter: c.field_show_year_filter,
          button: !c.field_button ? undefined : linkWrapper(c.field_button),
          press_releases: loadingAsyncState(() => getPressReleases<PressReleaseItem>())
        },
        {}
      ]
    })
  } else if (c.kind == 'stories_grid') {
    return some({
      kind: 'storiesBlock',
      value: [
        {
          block_index,
          title: c.field_title,
          link: !c.field_link ? undefined : linkWrapper(c.field_link),
          stories: loadingAsyncState(() => getOverview<ParsedNodeStory>('stories-overview', getLangFromUrl())),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      ]
    })
  } else if (c.kind == 'timeline') {
    return some({
      kind: 'timelineBlock',
      value: [
        {
          blockIndex: block_index,
          title: c.field_title,
          introduction: c.field_introduction,
          items: c.field_items
            .map((item) => ({
              title: item.field_title,
              introduction: item.field_introduction,
              media: item.field_media
            }))
            .toList(),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      ]
    })
  } else if (c.kind == 'text_with_image') {
    return some({
      kind: 'textImageBlock',
      value: [
        {
          blockIndex: block_index,
          imageLocation: c.field_featured_content_direction == 'image_left' ? 'left' : 'right',
          image: c.field_image,
          text: c.field_text,
          background: c.field_background,
          title: c.field_title,
          introduction: c.field_body,
          errors: Map(),
          push: undefined,
          primary_button: c.field_links.isEmpty() ? undefined : linkWrapper(c.field_links.get(0)),
          secondary_button:
            c.field_links.isEmpty() || c.field_links.count() <= 1 ? undefined : linkWrapper(c.field_links.get(1)),
          submit: unloadedAsyncState(),
          get_default_data_srcset: get_default_data_srcset,
          get_default_data_src: get_default_data_src
        },
        textImageClasses(c.field_featured_content_direction == 'image_left' ? 'left' : 'right')
      ]
    })
  } else if (c.kind == 'hubspot_form') {
    return some({
      kind: 'hubspotIFrameBlock',
      value: [
        {
          index: block_index,
          useCookieBar: true,
          cookiePlaceholder: GetCookiebarContent('iframe'),
          cookieButton: GetCookiebarButton('iframe'),
          inview: {
            threshold: 0.1,
            triggerOnce: true
          },
          inputfields: {
            portalID: c.field_portal_id,
            formID: c.field_form_id
          }
        },
        hubspotIframeBlockClasses
      ]
    })
  } else if (c.kind == 'text') {
    return some({
      kind: 'textBlock',
      value: {
        index: block_index,
        title: c.field_title,
        text: c.field_body,
        primary_button: c.field_links.isEmpty() ? undefined : linkWrapper(c.field_links.get(0)),
        link: c.field_links.isEmpty() || c.field_links.count() <= 1 ? undefined : linkWrapper(c.field_links.get(1)),
        link_type: false,
        background: c.field_background,
        inview: {
          threshold: 0.1,
          triggerOnce: true
        }
      }
    })
  } else if (c.kind == 'expandable_content_blocks') {
    return some({
      kind: 'expandBlock',
      value: {
        index: block_index,
        title: c.field_title,
        intro: c.field_introduction,
        items: c.field_expandable_content_blocks
          .filter((x) => x !== undefined)
          .map<expandProps>((e, i) => {
            if (e.field_content_block.first() == undefined) return undefined

            let images: CMSState['images'] = Map()
            let blocksdata = e.field_content_block
              .map((b) => {
                const blocky = { ...b, kind: b.bundle }
                let res = DrupalBlock_To_WidgetBlock(blocky as Block | CustomBlock, i, undefined, CustomBlock_To_Widget)
                let images_to_load = GetDrupalBlockImagesLoaders(blocky as Block | CustomBlock)
                images_to_load.forEach((i) => {
                  if (!images.has(i[0])) {
                    images = images.set(i[0], i[1])
                  }
                })
                return res
              })
              .filter((b) => b != undefined && b.kind == 'r')
              .toArray()

            if (blocksdata.length == 0) return undefined

            let title = e.field_title
            let subtitle = e.field_subtitle ? e.field_subtitle : undefined
            let text = e.field_body ? e.field_body : undefined

            return {
              index: block_index,
              block: blocksdata.map((b): NestedBlock | undefined => {
                if (b.kind == 'l') return undefined
                const nestedBlock = b.v
                switch (nestedBlock.kind) {
                  case 'textBlockNested':
                    return {
                      ...nestedBlock.value,
                      kind: 'nestedTextBlock',
                      body: nestedBlock.value.text
                    }
                  case 'quoteBlockNested':
                    return {
                      ...nestedBlock.value,
                      kind: 'nestedQuoteBlock',
                      text: nestedBlock.value.text,
                      author: nestedBlock.value.author
                    }
                  case 'downloadBlockNested':
                    return {
                      ...nestedBlock.value,
                      kind: 'nestedDownloadBlock',
                      items: nestedBlock.value.items.map((item) => ({
                        title: item.title,
                        text: item.text,
                        url: item.file_url
                      }))
                    } as NestedBlock
                  // ⚠️⚠️⚠️⚠️
                  // APPARENTLY MEDIA BLOCK NESTED ISN'T USED!!!!!!!!!
                  // ⚠️⚠️⚠️⚠️
                  // case 'mediaBlockNested':
                  //   const imageSrc = (item: MediaItemNestedProps) => {
                  //     const image = images.get(item.image)
                  //     // We know this is always loaded, see `image_utils.mod.ts`
                  //     if (image.kind != 'loaded') {
                  //       throw new Error(
                  //         `Image with id ${item.image} is not loaded yet. Ensure that the image is loaded before accessing its value.`
                  //       )
                  //     }
                  //     return image.value
                  //   }
                  //   return {
                  //     kind: 'nestedMediaBlock',
                  //     items: nestedBlock.value[0].items.map((item) =>
                  //       item.kind == 'video'
                  //         ? {
                  //             kind: 'nestedMediaBlock',
                  //             mediaType: 'video',
                  //             url: item.video.url,
                  //             provider: item.video.type,
                  //             caption: item.caption
                  //           }
                  //         : {
                  //             kind: 'nestedMediaBlock',
                  //             mediaType: 'image',
                  //             caption: item.caption,
                  //             image: {
                  //               alt: item.image_alt,
                  //               src: imageSrc(item).get(item.get_default_data_src()),
                  //               crops: item.get_default_data_srcset().map(([ url, width ]) => ({
                  //                 url: imageSrc(item).get(url),
                  //                 width: Number(width)
                  //               }))
                  //             }
                  //           }
                  //     )
                  //   }
                  case 'officeBlock':
                    const {
                      address,
                      city,
                      country,
                      street,
                      subTitle,
                      body,
                      email,
                      fax,
                      introduction,
                      mainTitle,
                      maplink,
                      postalAddress,
                      postalCity,
                      postalCode,
                      postalCountry,
                      postalStreet,
                      postcode,
                      telephone,
                      title,
                      website
                    } = nestedBlock.value
                    return {
                      ...nestedBlock.value,
                      kind: 'nestedOfficeBlock',
                      title: mainTitle,
                      intro: introduction,
                      body: body,
                      address: {
                        title: title,
                        visiting:
                          address || street || postcode || city || country || maplink
                            ? {
                                address,
                                street,
                                code: postcode,
                                city,
                                country,
                                mapLink:
                                  maplink && maplink.title && maplink.url
                                    ? {
                                        ...maplink,
                                        isExternal: true
                                      }
                                    : undefined
                              }
                            : undefined,
                        postal:
                          postalAddress || postalStreet || postalCode || postalCity || postalCountry
                            ? {
                                address: postalAddress,
                                street: postalStreet,
                                code: postalCode,
                                city: postalCity,
                                country: postalCountry
                              }
                            : undefined
                      },
                      contact: {
                        title: subTitle,
                        email,
                        telephone,
                        fax,
                        website: website && website.title && website.url ? { ...website, isExternal: true } : undefined
                      }
                    }
                }
              }),
              blockTitle: c.field_title,
              open: false,
              title: title,
              subtitle: subtitle,
              text: text,
              useSVGIcons: true
            }
          })
          .filter((e) => e != undefined)
          .toArray(),
        link: !c.field_link ? undefined : linkWrapper(c.field_link),
        inview: {
          threshold: 0.1,
          triggerOnce: true
        }
      }
    })
  } else if (c.kind == 'cta') {
    return some({
      kind: 'ctaBlock',
      value: {
        index: block_index,
        intro: c.field_introduction,
        title: c.field_title,
        primary_button: c.field_links && c.field_links.count() > 0 ? linkWrapper(c.field_links.first()) : undefined,
        secondary_button: c.field_links && c.field_links.count() > 1 ? linkWrapper(c.field_links.last()) : undefined,
        link_type: false,
        theme: c.field_cta_background,
        buttons: undefined
      }
    })
  } else if (c.kind == 'double_text_with_image') {
    return some({
      kind: 'doubleTextImageBlock',
      value: [
        {
          index: block_index,
          image: c.field_image ? parseImage(c.field_image) : 0,
          secondary_image: c.field_secondary_image ? parseImage(c.field_secondary_image) : 0,
          imageLocation: c.field_featured_content_direction == 'image_left' ? 'left' : 'right',
          title: c.field_title ? c.field_title : '',
          text: c.field_body,
          secondary_text: c.field_secondary_content,
          image_size: 'large',
          secondary_image_size: 'large',
          image_alt_text:
            c.field_image && c.field_image.field_media_image.alt ? c.field_image.field_media_image.alt : '',
          secondary_image_alt_text:
            c.field_secondary_image && c.field_secondary_image.field_media_image.alt
              ? c.field_secondary_image.field_media_image.alt
              : '',
          primary_button: c.field_link ? buttonWrapper(c.field_link) : undefined,
          secondary_button: c.field_secondary_link ? buttonWrapper(c.field_secondary_link) : undefined,
          link_type: false,
          get_default_data_src: get_default_data_src,
          get_default_data_srcset: get_default_data_srcset,
          inview: {
            threshold: 0.1,
            triggerOnce: true
          }
        },
        doubleTextImageClasses(c.field_featured_content_direction == 'image_left' ? 'left' : 'right')
      ]
    })
  } else if (c.kind == 'downloads') {
    const unarchived = downloadBlock(
      { ...c, field_download_list: c.field_download_list.filter((d) => !d.field_archive).toList() },
      block_index
    )
    const archived = downloadBlock(
      { ...c, field_download_list: c.field_download_list.filter((d) => d.field_archive).toList() },
      block_index
    )
    return some({
      kind: 'downloadsBlock',
      value: {
        unarchivedBlock: unarchived.value as DownloadBlockProps,
        archivedBlock: {
          ...(archived.value as DownloadBlockProps),
          archived: 'archive_list_collapsed'
        }
      }
    })
  } else if (c.kind == '360_building_block') {
    return some({
      kind: 'Image360Block',
      value: [
        {
          index: block_index,
          image: c.field_image,
          previewImage: c.field_preview_image,
          mode: 'flat-image'
        },
        {} // styling object
      ]
    })
  } else if (c.kind === 'press') {
    return some({
      kind: 'pressContactBlock',
      value: [
        {
          blockIndex: block_index,
          contactPerson: loadingAsyncState(() => getPressContact(getDrupalLanguage(getLangFromUrl()))),
          pressContact: c.field_contact_person
        },
        { block_classname: 'some style classname' }
      ]
    })
  } else if (c.kind == 'updates') {
    return some({
      kind: 'updateBlock',
      value: [
        {
          block_index,
          title: c.field_title,
          link: !c.field_link ? undefined : linkWrapper(c.field_link),
          updateNodes: unloadedAsyncState(),
          allUpdates: unloadedAsyncState(),
          expertiseNodes: unloadedAsyncState(),
          errors: Map(),
          push: undefined,
          submit: unloadedAsyncState()
        },
        {}
      ]
    })
  } else if (c.kind == 'office') {
    return some({
      kind: 'officeBlock',
      value: {
        block_index,
        mainTitle: !c.field_main_title ? undefined : c.field_main_title,
        subTitle: c.field_subtitle,
        introduction: !c.field_introduction ? undefined : c.field_introduction,
        title: !c.field_title ? undefined : c.field_title,
        maplink: !c.field_map_link ? undefined : linkWrapper(c.field_map_link),
        address: !c.field_address ? undefined : c.field_address,
        postalAddress: !c.field_postaladdress ? undefined : c.field_postaladdress,
        country: !c.field_country ? undefined : c.field_country,
        postalCountry: !c.field_postal_country ? undefined : c.field_postal_country,
        email: !c.field_email ? undefined : c.field_email.toArray(),
        telephone: !c.field_telephone ? undefined : c.field_telephone.toArray(),
        fax: !c.field_fax ? undefined : c.field_fax.toArray(),
        street: c.field_street,
        postcode: c.field_postal_code,
        body: c.field_body,
        city: c.field_city,
        postalStreet: c.field_postal_street,
        postalCode: c.field_postal_code,
        postalCity: c.field_postal_city,
        website: !c.field_website ? undefined : linkWrapper(c.field_website)
      }
    })
  } else if (c.kind == 'contact') {
    return some({
      kind: 'contactBlock',
      value: [
        {
          block_index,
          description: c.field_introduction,
          title: c.field_title,
          link: !c.field_link ? undefined : linkWrapper(c.field_link),
          email: c.field_e_mail.toArray(),
          telephone: c.field_phone.toArray(),
          occupation: c.field_subtitle,
          name: c.field_name,
          image: c.field_image
        },
        {}
      ]
    })
  } else if (c.kind == 'job_alert') {
    return some({
      kind: 'jobAlertBlock',
      value: [
        {
          block_index,
          collapsed_status: 'collapse_closed'
        },
        {}
      ]
    })
  } else if (c.kind == 'development_block') {
    return some({
      kind: 'developmentBlock',
      value: [
        {
          title: c.field_title,
          images: c.field_images,
          image_size: '175x175',
          get_default_data_src: developmentblock_src,
          get_default_data_srcset: developmentblock_srcset
        },
        {}
      ]
    })
  }
  return none()
}
